export const Features = {
    count: 1,
    list: [
        {
            date: new Date("2026/06/06"),
            type: "Melhoria",
            contracts: [],
            flag: "customizationImprovement",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/customizacao-v2.png",
            title: "Customização mais simples e eficiente",
            description: `A ferramenta de customização foi reformulada para tornar a criação de indicadores, gráficos e dashboards mais fácil. Agora você pode aplicar suas customizações para toda a carteira ou apenas para as empresas selecionadas.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-customizar-graficos-e-dashboards"
        },
        {
            date: new Date("2026/02/02"),
            type: "Novo Recurso",
            contracts: [],
            flag: "unifiedDashes",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/dash-unificado.png",
            title: "Envie Dashes com todos os módulos",
            description: `Agora você pode realizar entregas unificadas em um único Dash, reunindo indicadores dos módulos Contábil, Financeiro, Fiscal e Pessoal. Para inserir os dados, é necessário que o módulo esteja ativo e com informações disponíveis. Acesse a empresa e compartilhe o Dash unificado.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dash-unificado"
        },
        {
            date: new Date("2025/09/04"),
            type: "Novo Recurso",
            contracts: [],
            flag: "personnelCheck",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/conferencia-pessoal.png",
            title: "Conferência no eSocial",
            description: `Agora é possível verificar os dados dos arquivos do eSocial. Basta acessar a seção ”Editar” da empresa e na aba de ‘Importar’ terá o botão ”Baixar Conferência”.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/quais-os-dados-sao-copiados-dos-arquivos-de-xml-do-esocial-para-a-plataforma-nuc"
        },
        {
            date: new Date("2025/09/04"),
            type: "Novo Recurso",
            contracts: [],
            flag: "preferencesDash",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/preferences-dash.png",
            title: "Seções do Dash editáveis",
            description: `Agora é possível <b>ocultar</b> algumas seções do Dash. Para configurar, basta gerar um Dash e escolher se deseja exibir ou ocultar as seções de <b>Benchmarking, Performance e Chat Nanda IA</b>.`
        },
        {
            date: new Date("2025-07-20T17:51:09.289Z"),
            type: "Novo Recurso",
            contracts: [],
            flag: "newDashboardReport",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/Novo_Dashboard_2.0.png",
            title: "Nova experiência de análise para seu cliente",
            description: `<strong>Conheça o Dash</strong>, a nova forma de compartilhar dados na Nucont. Com <strong>funcionalidades inéditas</strong> como envio de conteúdos interativos, chat com IA, integração com WhatsApp e acesso de qualquer dispositivo. Basta acessar o <strong>'Dashboard'</strong> da empresa e clicar em <strong>"Compartilhar"</strong>. `,
            redirects: [
                {
                    label: "Saiba mais",
                    href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dash-nova-ferramenta-de-analise-para-seu-cliente"
                }
            ]
        },
        {
            date: new Date("2025-03-19T17:51:09.289Z"),
            type: "Novo Recurso",
            contracts: [],
            flag: "eSocialAutomation",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/automacao-esocial.png",
            title: "Integração: dados do eSocial automáticos",
            description: `Agora é possível inserir empresas e dados do eSocial por meio da integração com o Certificado Digital. Você <strong>ganhará 5 conexões</strong>, mas poderá contratar mais. Para conectar, acesse 'eSocial' em <strong>Integrações</strong> (  <img src='assets/icons/nucont-conecte.svg'>  ), insira a senha e o Certificado Digital.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-esocial-modulo-pessoal"
        },
        {
            date: new Date("2024-12-19T17:51:09.289Z"),
            type: "Novo",
            contracts: [],
            flag: "addNewCompanyFeature",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/adicionar-empresa-arquivo.png",
            title: "Pule etapas e ganhe tempo!",
            description: `Agora é possível adicionar empresas e inserir dados ao mesmo tempo. Basta ir em <strong>"Adicionar empresa"</strong>, clicar na aba <strong>"Inserir arquivo"</strong> e importar os arquivos desejados.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-cadastrar-empresas"
        },
        {
            date: new Date("2024-12-19T16:25:12.273Z"),
            type: "Melhoria",
            contracts: [],
            flag: "companyBusinessAccessFeature",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/accesso-empresario-grupo.png",
            title: "Vocês pediram, e nós entregamos!",
            description: `Agora, os empresários também podem <strong>acessar o dashboard dos grupos</strong> diretamente pelo seu login. E tem mais: na <strong>automação</strong> você poderá definir uma data fixa e a frequência desejada dos Dashes, deixando ainda mais customizável.</br></br>
Tem alguma <strong>sugestão</strong> ou <strong>ideia</strong>? Compartilhe com a gente! Quem sabe sua ideia não vira a nossa próxima novidade? 😉
`,
            redirects: [
                {
                    label: "Ver mais acesso grupo",
                    href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/grupo-de-empresas"
                },
                {
                    label: "Ver mais automação",
                    href: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
                }
            ]
        },

        {
            date: new Date("2024-12-01T14:32:48.437Z"),
            type: "Novo Recurso",
            contracts: [],
            flag: "newDashboardCompany",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/dashboard-carteira.png",
            title: "Todos os insights em um só lugar",
            description: `Tenha uma visão completa da contabilidade com o novo dashboard. Veja <b>integrações</b> ativas ou desatualizadas, <b>automações</b> agendadas, <b>gráficos</b> de dispersão, métricas de <b>avaliação</b> e muito mais. Tudo o que você precisa, agora em um só lugar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dashboards-da-carteira"
        },
        {
            date: new Date("2024-12-01T14:32:48.437Z"),
            type: "Novo Recurso",
            contracts: [],
            flag: "cadsim",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/importar-cadsim.png",
            title: "Importe a carteira de clientes com CadSim!",
            description: `Com apenas alguns cliques, transfira toda a sua carteira ativa no Cadsim e administre tudo de forma eficiente na Nucont. Simplifique sua gestão e aproveite essa novidade!`,
            customAction: ({ $state }) => {
                const link = $state.href(
                    "nucont.accounting.journey.import.cadsim"
                );
                window.open(link, "_blank");
            },
            customActionLabel: {
                label: "Importar Carteira"
            },
            customActionRedirect: {
                redirectIcon: `<i class="fas fa-external-link-alt "></i>`
            }
        },
        {
            date: new Date("2024-12-01T14:32:48.437Z"),
            type: "Melhoria",
            contracts: [],
            flag: "designDashboard",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/visa-carteira.png",
            title: "A Carteira está de cara nova!",
            description: `Agora nossa tabela está ainda mais prática e organizada! Confira as novas divisões para facilitar sua navegação. Basta clicar na aba desejada e encontrar as informações que procura de forma rápida e eficiente.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/carteira"
        },

        {
            date: new Date("2024-12-01T14:32:48.437Z"),
            type: "Melhoria",
            contracts: [],
            flag: "dominio",
            image: "https://nucont-imgs.s3.us-east-1.amazonaws.com/novidades/dominio-conectar-todos.png",
            title: "Domínio: Todos os dados de uma só vez!",
            description: `Agilidade e praticidade na importação de dados! Agora, na Domínio, você pode integrar várias empresas de uma só vez com apenas alguns cliques.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/integracao-e-automacao-de-dados-do-sistema-dominio-web"
        },
        {
            date: new Date("2024-10-01T14:32:48.437Z"),
            type: "Melhoria",
            contracts: [],
            flag: "integrationContabit",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/contabit.png",
            title: "Nova integração Contabit!",
            description: `Já está disponível o primeiro software contábil a utilizar nossa nova API pública! Se você é cliente Contabit, a integração pode ser realizada na aba de Integrações ( <i class="fas fa-sync-alt"></i> ) > Integra Dashboard, no seu sistema.`
        },
        {
            date: new Date("2024-10-01T14:31:48.437Z"),
            type: "Melhoria",
            contracts: [],
            flag: "tokenApiIntegration",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/token-api.png",
            title: "Novo Token de API disponível!",
            description: `Agora, a Nucont possui uma API pública para integrar novos softwares contábeis, possibilitando assim o envio de dados. A chave estará disponível no seu perfil de usuário ( <i class="fas fa-user-alt"></i> ). Basta clicar no botão ( <i class="far fa-copy"></i> ) para copiá-la para a área de transferência. Compartilhe essa novidade com seus parceiros e solicite a integração.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/api-modulo-contabil"
        },
        {
            date: new Date("2024/09/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "previstorealizado",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/previsto-realizado.png",
            title: "Financeiro: dashboard Previsto X Realizado",
            description: `Agora, através das <b>integrações</b> do <b>Financeio</b>, você pode acessar o novo dashboard de dados <b>Previstos X Realizados</b>. Compare facilmente os resultados esperados com os alcançados e tenha uma visão mais clara do desempenho financeiro da sua empresa.`
        },
        {
            date: new Date("2024/09/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "omienovasfontes",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/nibo-omie-competencia.png",
            title: "Financeiro: novos dados integrados!",
            description: `Agora, as integrações <b> Nibo </b> e <b> Omie </b> terão os <b> dados previsto </b> e será possível ativar <b> ambos os regimes </b>! Ao ativá-los, os dados adicionais serão enviados para a aba 'Cenário', cada um com seu respectivo cenário. Se desejar ativar esta configuração, acesse Integrações, clique em (  <i class="fas fa-ellipsis-v"></i>   ) e selecione ”Configurar integração”.`,

            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-omie-modulo-financeiro"
        },
        {
            date: new Date("2024/08/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "contactsManagementFeature",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/contatos-feature.png",
            title: "Todos os contatos em um só lugar!",
            description: `Agora, todos os seus contatos estão reunidos em um só lugar, na nova seção 'Contatos'. Gerencie os acessos dos contatos existentes e adicione novos de forma rápida e fácil. Explore essa funcionalidade hoje mesmo!`,
            customAction: ({ $state }) => {
                const link = $state.href(
                    "nucont.accounting.contactsManagment.companies",
                    {
                        accountingId: $state.params.accountingId,
                        openConfig: 0
                    }
                );
                window.open(link, "_blank");
            },
            customActionLabel: {
                label: "Acessar Contatos"
            },
            customActionRedirect: {
                redirectIcon: `<i class="fas fa-external-link-alt "></i>`
            }
        },
        {
            date: new Date("2024/08/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "financeiroRegimeCenario",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/nibo-regime-cenario.png",
            title: "NIBO: Novos dados integrados!",
            description: `Agora, a integração da NIBO terá os <b>dados previstos</b> e será possível ativar <b>ambos os regimes</b>! Ao ativá-los, os dados adicionais serão enviados para a aba 'Cenário', cada um com seu respectivo cenário. Se desejar ativar esta configuração, acesse Integrações, clique em ( <i class="fas fa-ellipsis-v"></i> ) e selecione ”Configurar integração”.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-nibo-modulo-financeiro"
        },
        {
            date: new Date("2024/06/10"),
            type: "Melhoria",
            contracts: ["Automation"],
            flag: "automationIntegrationCompanies",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/atualizacao-automatica.png",
            title: "Financeiro: Atualização automática de dados",
            description: `Agora, a integração de todos os softwares Financeiros possui automação nas atualizações de dados, o que significa que você não precisa mais se preocupar em atualizar manualmente mensalmente. Caso queira modificar a data da atualização automática, basta acessar: Integrações > <i class="fas fa-sync"></i>     Atualizar dados e editar a data desejada.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
        },

        {
            date: new Date("2024/05/21"),
            type: "Melhoria",
            contracts: [],
            flag: "regenerateReportsPending",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/reagendar-pendencia.png",
            title: "Reagende Dash com pendências em um clique!",
            description: `Agora você pode reagendar Dash com erros de automação de forma rápida e fácil. Após resolver as pendências, basta acessar a "Central de Dash" e clicar em "Reagendar Pendências" ou selecione as pendências que deseja reagendar.
            `,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
        },
        {
            date: new Date("2024/05/01"),
            type: "Novo Recurso",
            contracts: ["Análise Plus"],
            flag: "experimenteAnalisePlus",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/analise-plus-novidade.png",
            title: "Experimente agora a Análise Plus",
            description: `
            Agora é possível testar todos os benefícios da Análise Plus (<img src='assets/icons/analyze-plus-stars.svg' >), basta acessar a Empresa Modelo e testar <b>Projeção</b>, <b>Orçamento</b> e <b>Objetivo</b>.`,
            customAction: ({ $state }) => {
                const link = $state.href(
                    "nucont.accounting.company.dashboards.view",
                    {
                        accountingId: $state.params.accountingId,
                        id: "EMPRESA_MODELO",
                        accIdReference: $state.params.accountingId
                    }
                );
                window.open(link, "_blank");
            },
            customActionLabel: {
                svg: "assets/icons/analyze-plus-stars.svg",
                label: "Teste agora a novidade"
            }
        },
        {
            date: new Date("2024/04/25"),
            type: "Melhoria",
            contracts: [],
            flag: "datesInterval",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/intervalo-datas.png",
            title: "Personalize o período de sua análise",
            description: `Agora você pode personalizar o período da análise inserindo uma data de início e uma data de término. Essa melhoria está disponível no Dashboard e na DRE.
            `,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dre-demonstracoes"
        },
        {
            date: new Date("2024/03/25"),
            type: "Novo Recurso",
            contracts: ["Análise Plus"],
            flag: "analisePlus",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/objetivos.png",
            title: "Acompanhe o progresso dos resultados",
            description: `Agora é possível verificar se os indicadores estão alcançando as metas e objetivos estabelecidos e monitorar o progresso dos resultados de seus clientes. Basta entrar no Dashboard e ativar a Análise Plus ( <img src='assets/icons/analyze-plus-stars.svg' > ).
            `,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/analise-plus-objetivos"
        },
        {
            date: new Date("2024/03/22"),
            type: "Novo Recurso",
            contracts: ["Análise Plus"],
            flag: "analisePlus",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/orcamento.png",
            title: "Acompanhe os resultados frente ao Orçamento.",
            description: `Agora é possível estimar despesas e receitas e acompanhar os resultados frente ao que foi orçado, permitindo tomar ações mais rapidamente. Basta acessar o menu lateral ( <i class='fas fa-coins'></i>  ) e criar o primeiro orçamento.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/analise-plus-orcamento"
        },
        {
            date: new Date("2024/03/22"),
            type: "Novo Recurso",
            contracts: ["Análise Plus"],
            flag: "analisePlus",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/projecao.png",
            title: "Projete os resultados e identifique Oportunidades.",
            description: `Agora é possível projetar os resultados das empresas (Inclusive automaticamente via regressão linear), permitindo identificar tendências e oportunidades para seus clientes. Basta acessar o Dashboard e ativar a Análise Plus ( <img src='assets/icons/analyze-plus-stars.svg' > ).`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/analise-plus-projecao"
        },
        {
            date: new Date("2024/03/22"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "demonstracoesMelhorias",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/demonstracoes-melhorias.png",
            title: "Demonstrações ainda mais completa!",
            description: `Agora é possível visualizar análise vertical e horizontal na tabela de DRE e Balanço. Basta clicar no botão ( <img src='assets/icons/icon-comparation.svg' > ) e selecionar o período que deseja comparar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dre-demonstracoes"
        },
        {
            date: new Date("2024/03/22"),
            type: "Melhoria",
            contracts: ["Análise Plus"],
            flag: "analisePlus",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/cenario-aumento.png",
            title: "Crie Cenário com mais facilidade",
            description: `Agora é possível utilizar atalhos na criação de cenários, otimizando o tempo de preenchimento.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/analise-plus-cenario"
        },
        {
            date: new Date("2023/10/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "reportViewing",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/central-relatorios.png",
            title: "Experimente a visualização anônima.",
            description: `Agora é possível remover a obrigação de identificação para visualizar os Dash compartilhados. Ative a Visualização Anônima na Central de Dash (  <i class="fas fa-share-alt"></i>  ) e permita o compartilhamento de Dash sem a necessidade de identificação do usuário, por meio de nome e e-mail.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
        },

        {
            date: new Date("2023/09/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "pgdasIntegration",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/serpro.png",
            title: "Integre dados fiscais com o Simples Nacional",
            description: `Agora você consegue automatizar a importação do Simples Nacional com apenas alguns cliques. Basta ir no Conecte (  <img src='assets/icons/nucont-conecte.svg'>  ) assinar o certificado digital e os arquivos de PGDAS irão automaticamente para as empresas vinculadas .`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-pgdas-modulo-fiscal"
        },
        {
            date: new Date("2023/09/01"),
            type: "Novo Recurso",
            contracts: [],
            flag: "automation",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/automacoes.png",
            title: "Automação de entregas de Dash!",
            description: `Agora é possível automatizar todo o processo de geração de Dash e realizar entregas sem nenhum esforço manual. Para ativar, basta acessar a opção (  <i class="fas fa-robot"></i>  ) "Automações" no menu lateral e ativar o modo de piloto automático ou criar a sua primeira automação.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/automacao-e-central"
        },
        {
            date: new Date("2023/08/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "dreAccouting",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/csat.png",
            title: "Acompanhe o nível de satisfação do Nucontent!",
            description: `Agora junto com o envio do Nucontent você conseguirá medir o nível de satisfação do seu cliente com conteúdo. Acesse ( <i class="fas fa-envelope-open-text"></i> ) e veja o que mudou!`,
            redirect: "https://atendimento.nucont.com/hc/central-de-conhecimento/pt_BR"
        },
        {
            date: new Date("2023/08/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "dreAccouting",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/dre-contabil.png",
            title: "Personalize a DRE contábil!",
            description: `Agora é possível habilitar e desabilitar contas e subcontas! Basta abrir o drilldown ( <i class="fas fa-sort-down"></i> ) das contas na tabela e habilitar/desabilitar as contas que desejar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/dre-demonstracoes"
        },

        {
            date: new Date("2023/06/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "pgdasCopyNovidade",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/copia-pgdas.png",
            title: "Copiar dados de Receita do PGDAS!",
            description: `Agora você consegue copiar os dados de Receita do PGDAS para o módulo Pessoal e para plano de contas padrão do Fiscal, basta clicar no botão (<i class='fas fa-file-import'></i>) e selecionar de onde deseja copiar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/copia-de-dados-para-o-modulo-fiscal"
        },
        {
            date: new Date("2023/06/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "eSocialNovidade",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/esocial-import.png",
            title: "Nova opção de importação no pessoal",
            description: `Importar dados ficou ainda mais fácil, agora você tem a opção de importar o arquivo .xml do <b>eSocial</b> no departamento pessoal.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/importacao-esocial"
        },
        {
            date: new Date("2023/04/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "integracaoFinanceiroOmie",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/omie-novidade.png",
            title: "Integre dados financeiros com a Omie",
            description: `Omie chegou na Nucont! Importe os dados financeiros de forma automática, basta acessar no menu lateral Integrações ( <img src='assets/icons/nucont-conecte.svg' > ) e selecionar qual empresa deseja integrar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-integrar-com-omie-modulo-financeiro"
        },
        {
            date: new Date("2023/04/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "comparacaoDemonstracoes",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/comparacao-demonstracoes.jpeg",
            title: "Demonstrações ainda mais completa!",
            description: `Agora é possível visualizar <b> análise vertical </b> e <b> horizontal </b> na tabela de DRE e Balanço. Basta clicar no botão ( <img src='assets/icons/icon-comparation.svg'> ) e selecionar o período que deseja comparar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/comparacao-na-dre-demonstracoes"
        },
        {
            date: new Date("2023/04/01"),
            type: "Melhoria",
            contracts: ["Standard", "Starter", "Professional", "Expert"],
            flag: "comparacaoAvancadaFeature",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/comparacao-avancada.png",
            title: "Nossos gráficos estão mais completos!",
            description: `Agora é possível <b>criar uma comparação</b> nos gráficos do dashboard. Basta clicar no botão ( <img id='ComparacaoAvancadaIcon' src="assets/icons/icon-compare.svg"> ) e selecionar a base de dados e período que desejar.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/comparacao-em-dashboards"
        },
        {
            date: new Date("2023/03/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "cenariosDpFiscal",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/cenarios-dp-fiscal.png",
            title: "Crie cenários no módulo Fiscal e Pessoal!",
            description: `Agora você pode criar cenários no módulo Fiscal e Pessoal e fazer projeções para futuras comparações. Basta ir na aba de <b>Dados</b> e criar o cenário que quiser.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/criando-cenarios"
        },
        {
            date: new Date("2023/03/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "nucontScore",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/nucont-score-news+(1).png",
            title: "Chegou o Nucont Score!",
            description: `Agora as importações e entregas contabilizam um score geral que vai de 0% a 100%. Acompanhe clicando no botão (<b>Detalhes</b>) e veja como manter o score da contabilidade sempre alto.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/nucont-score"
        },
        {
            date: new Date("2023/02/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "npsFeature",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/nps-feature.png",
            title: "Envie pesquisa de NPS para seus clientes!",
            description: `Agora é possível realizar pesquisas NPS com seus clientes de forma automática. Basta clicar no ícone ( <i class='fas fa-star-half-alt'></i> ) no menu lateral esquerdo e ativar as empresas para as quais você deseja enviar a pesquisa.`,
            redirect: "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/nps"
        },
        {
            date: new Date("2022/12/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "pgdas",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/pgdas-feature.png",
            title: "Nova opção de importação no fiscal",
            description: `Importar dados ficou ainda mais fácil, agora você tem a opção de importar o arquivo .pdf do <b>PGDAS (Simples Nacional)</b> no departamento fiscal.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-usar-a-funcionalidade-analises-pgdas"
        },
        {
            date: new Date("2022/11/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "helperCenter",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/centrla-ajuda.png",
            title: "Agora temos ajuda na plataforma!",
            description: `Surgiu alguma dúvida enquanto navega? Verifique se existe o botão de ajuda no canto direito e aprenda mais sobre a função que deseja utilizar na plataforma.`,
            redirect: "https://atendimento.nucont.com/hc/central-de-conhecimento/pt_BR"
        },
        {
            date: new Date("2022/08/01"),
            type: "Novo recurso",
            contracts: ["Expert"],
            flag: "dashboardThemes",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/dashboard-colors.svg",
            title: "Novas paletas de cores para seu Dashboard!",
            description: `Agora você pode alterar a paleta de cores do seu Dashboard quando quiser. Basta acessar a Dashboard, clicar no botão (<i class='fas fa-palette'></i>) e escolher o tema que mais combina com sua contabilidade!`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-alterar-os-temas-de-cores-dos-graficos-dashboards-e-relatorios"
        },
        {
            date: new Date("2022/07/01"),
            type: "Novo recurso",
            contracts: ["Expert"],
            flag: "groups",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/group-analytics.svg",
            title: "Chegou a Análise em Grupo",
            description: `Criando um grupo de empresas você poderá visualizar a análise somada, media, acesso aos dashboards, Dash e demonstrações em conjunto. Basta clicar no botão ( <div class='icon-news icon-group'></div> )  na carteira e criar o seu primeiro grupo.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/grupo-de-empresas"
        },
        {
            date: new Date("2022/05/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "batchImport",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/import-data-batch.svg",
            title: "Importar dados em lote",
            description: `Agora você pode importar dados em conjunto de até 15 empresas. Basta acessar no menu lateral (<div class='icon-news icon-batch-import'></div>) , selecionar quais empresas deseja preencher dados, baixar a planilha modelo e importar os dados.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-realizar-importacoes-de-dados-em-lote"
        },
        {
            date: new Date("2022/06/01"),
            type: "Novo recurso",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "darkMode",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/darkmode.svg",
            title: "Chegou o tema escuro!",
            description: `Basta clicar na nova central do usuário ( <i class="fas fa-user"></i>) e selecionar o tema escuro. Pronto, a mágica acontece.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-alterar-os-temas-de-cores-dos-graficos-dashboards-e-relatorios"
        },
        {
            date: new Date("2022/05/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "financialCustomImport",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/module-financial.svg",
            title: "O módulo Financeiro está de cara nova!",
            description: `Uma nova versão do módulo financeiro está no ar, com criação de contas personalizadas, novo plano de contas completo com base na demonstração de fluxo de caixa e dashboards interativos e customizados.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/como-inserir-dados-em-empresas-modulo-financeiro"
        },

        {
            date: new Date("2022/04/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "departmentCopySerie",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/copy-data-balance-sheet.svg",
            title: "Copiar dados do Fiscal e do Balancete!",
            description: `Ficou mais fácil preencher os dados da tabela na Nucont, basta clicar no botão (<i class="fas fa-file-import"></i>) e selecionar de onde deseja copiar. `,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/copia-de-dados-no-modulo-pessoal"
        },
        {
            date: new Date("2022/01/01"),
            type: "Melhoria",
            contracts: ["Starter", "Professional", "Expert"],
            flag: "shareReport",
            image: "https://nucont-imgs.s3.amazonaws.com/novidades/share-reports-wp.svg",
            title: "Compartilhar Dash via Whatsapp",
            description: `Compartilhar Dash ficou ainda mais fácil! 
            Agora além de compartilhar por email, você 
            poderá compartilhar pelo WhatsApp.`,
            redirect:
                "https://atendimento.nucont.com/hc/central-de-conhecimento/articles/compartilhar-o-indicador-via-whatsapp"
        }
    ]
};
